











import { Vue, Component } from 'vue-property-decorator';
import vClickOutside from 'v-click-outside'

import IconNotification from '@/components/icons/Notify.vue';
import IconNotificationHas from '@/components/icons/NotifyHas.vue';
import NotificationsModule from '@/store/notifications';
import { EventBus } from '@/lib/EventBus';

export interface NotificationItem {
    body: string,
    id: number,
    link: string,
    readAt: string | null,
    title: string,
    _actions: string[],
}

@Component({
    components: {
        IconNotification,
        IconNotificationHas,
    },
    directives: {
        clickOutside: vClickOutside.directive,
    }
})
export default class AppMenuNotification extends Vue {
    isShowList = false;
    notifications: NotificationItem[] = [];
    currentPage = 1;
    totalPages = 1;
    isLoading = false;

    get hasUnread() {
        return NotificationsModule.notifications.filter(notification => !notification.readAt).length;
    }

    toggleListVisible() {
        NotificationsModule.toggleIsShow();
    }

    hideList() {
        NotificationsModule.updateIsShow(false);
    }

    updateNotifications() {
        NotificationsModule.updateNotifications();
    }

    init() {
        NotificationsModule.init();
    }

    mounted() {
        this.init();
        EventBus.$on('notification:new', this.updateNotifications);
    }
}
